import React, { useRef } from 'react';
import { ConditionWithDetails } from '../../../../api/conditions';
import ConditionsTableRow from './ConditionsTableRow';
import TableSkeleton from '../../../BaseComponents/TableSkeleton';
import './ConditionsTable.scss';
import downArrow from '../../../../assets/icons/downArrow.png';

interface ConditionsTableProps {
  conditionsList: ConditionWithDetails[];
  isLoading: boolean;
  sortingLoading: boolean;
  onViewCondition: (condition: ConditionWithDetails) => void;
  onEditCondition: (condition: ConditionWithDetails) => void;
  onDeleteCondition: (conditionId: number) => void;
  onSort: (field: string) => void;
}

const ConditionsTable: React.FC<ConditionsTableProps> = ({ 
  conditionsList, 
  isLoading, 
  sortingLoading,
  onViewCondition,
  onEditCondition, 
  onDeleteCondition,
  onSort
}) => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  if (isLoading) {
    return (
      <div className='conditions-container'>
        <div className='conditions-table'>
           <div className='table-header'>
             <div className='header-cell'>Name of the condition <img src={downArrow} alt="" style={{  cursor: 'pointer' }} onClick={() => onSort('name')} /></div>
             <div className='header-cell'>Body systems <img src={downArrow} alt="" style={{ cursor: 'pointer' }} onClick={() => onSort('body_system')} /></div>
             <div className='header-cell'>Description</div>
             <div className='header-cell'>Associated biomarkers</div>
             <div className='header-cell'>Associated FBS conditions</div>
             <div className='header-cell'></div>
           </div>
          <div className='table-body' ref={scrollContainerRef}>
            <div className='loading-state'>
              <div className='loading-spinner'></div>
              <div className='loading-text'>Loading conditions...</div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className='conditions-container'>
      <div className='conditions-table'>
         <div className='table-header'>
           <div className='header-cell'>Name of the condition <img src={downArrow} alt="" style={{ cursor: 'pointer' }} onClick={() => onSort('name')} /></div>
           <div className='header-cell'>Body systems <img src={downArrow} alt="" style={{ cursor: 'pointer' }} onClick={() => onSort('body_system')} /></div>
           <div className='header-cell'>Description</div>
           <div className='header-cell'>Associated biomarkers</div>
           <div className='header-cell'>Associated FBS conditions</div>
           <div className='header-cell'></div>
         </div>
        <div className='table-body' ref={scrollContainerRef}>
          {sortingLoading ? (
            <TableSkeleton rows={5} columns={6} />
          ) : conditionsList?.length > 0 ? (
            conditionsList.map((condition) => (
              <ConditionsTableRow
                conditionData={condition}
                key={condition.id}
                onViewCondition={onViewCondition}
                onEditCondition={onEditCondition}
                onDeleteCondition={onDeleteCondition}
              />
            ))
          ) : (
            <div className='empty-state'>
              <div className='empty-text'>No conditions found</div>
              <div className='empty-subtext'>Click "Add condition" to create your first condition.</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConditionsTable;
